import { Box, LinearProgress } from '@material-ui/core';
import React from 'react';

export function LoadingLayer(props: { loading: boolean }) {
  const { loading } = props;

  const linearLoadingStyle = {
    position: 'fixed',
    zIndex: 12,
    top: 0,
    left: 0,
    width: '120vw',
    opacity: loading ? 1 : 0,
    transition: 'opacity 0.8s 0.1s',
  } as React.CSSProperties;

  return (
    <>
      <Box style={linearLoadingStyle}>
        <LinearProgress style={{ height: '4px' }} />
      </Box>
      {/*{loading && <LongLoadingMessage />}*/}
    </>
  );
}
